import React from 'react';
import { useModal } from 'venn-utils';
import SearchMenuBar from '../../../../../search-menu/SearchMenuBar';
import { MappedPortfolioNodeCellRendererRoot } from './MappedPortfolioNodeCellRendererRoot';
import type { MappedPortfolioNodeCellRendererProps } from './types';
import { useMappedPortfolioSearchMenuBar } from './useMappedPortfolioSearchMenuBar';

export const MappedProFormaPortfolioNodeCellRenderer = ({
  isFundIdDisabledForMapping,
  onApplyMapping,
  node,
  needsMapping,
  allowRemapping,
  isFundRemapped,
}: MappedPortfolioNodeCellRendererProps) => {
  const fundName = node?.data?.node?.name;
  const fundId = node?.data?.node?.fund?.id;
  const [isSearchOpen, openSearch, closeSearch] = useModal();
  const {
    refreshedStyling,
    autofocus,
    defaultMenuIsOpen,
    privateAssetSearchMode,
    investmentsOnly,
    isOptionDisabled,
    customPlaceholder,
    optionDisabledTooltipContent,
    getOptionValue,
    onBlur,
    onSelected,
    location,
  } = useMappedPortfolioSearchMenuBar({
    closeSearch,
    node,
    onApplyMapping,
    isFundIdDisabledForMapping,
    fundName,
  });

  const isRemappedByUser = fundId ? isFundRemapped[fundId] || false : false;

  return (
    <MappedPortfolioNodeCellRendererRoot
      openSearch={openSearch}
      isSearchOpen={isSearchOpen}
      closeSearch={closeSearch}
      allowRemapping={allowRemapping}
      isRemapped={isRemappedByUser}
      needsMapping={needsMapping}
      shouldCloseSearchOnScroll
    >
      <SearchMenuBar
        refreshedStyling={refreshedStyling}
        autofocus={autofocus}
        defaultMenuIsOpen={defaultMenuIsOpen}
        privateAssetSearchMode={privateAssetSearchMode}
        investmentsOnly={investmentsOnly}
        isOptionDisabled={isOptionDisabled}
        customPlaceholder={customPlaceholder}
        optionDisabledTooltipContent={optionDisabledTooltipContent}
        getOptionValue={getOptionValue}
        onBlur={onBlur}
        onSelected={onSelected}
        location={location}
      />
    </MappedPortfolioNodeCellRendererRoot>
  );
};
